import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { routes } from "router/routes"
import { Icon } from "ui/Icon"
import styles from "./BlackoutConflictBanner.module.css"

/**
 * Shown when this reservation falls inside a blackout and has to be cancelled or moved.
 *
 * "View Blackout" goes to Blackout Settings rather than the specific record — the settings
 * page lists every blackout and is where the guide would change or remove it.
 */
const BlackoutConflictBanner = ({ conflict }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  if (!conflict) return null

  return (
    <Flex align="center" gap="var(--spacing-xs)" wrap className={styles.banner}>
      <Icon name="AlertTriangle" width={20} height={20} color="var(--color-error)" />
      <span className={styles.message}>
        {t("booking.reservation_detail.blackout_conflict", {
          defaultValue: "Cancellation or rescheduling required due to {{label}}",
          label: conflict.label
        })}
      </span>
      <button type="button" className={styles.link} onClick={() => navigate(routes.proSettingsBlackout())}>
        {t("booking.reservation_detail.view_blackout", { defaultValue: "View Blackout" })}
      </button>
    </Flex>
  )
}

BlackoutConflictBanner.propTypes = {
  conflict: PropTypes.shape({
    label: PropTypes.string
  })
}

export default BlackoutConflictBanner
